import React from 'react';
import {Link} from 'react-router-dom'
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import RequestListTable from './RequestListTable';
import Utility from "../../Utility";
import ApiFetcher from "../../ApiFetcher";
import indigo from "@material-ui/core/colors/indigo";

const styles = theme => ({
    root: {
        textAlign: 'center'
    },
    form: {
        margin: 'auto',
        width: '80%',
    },
    paper: {
        margin: theme.spacing.unit,
    },
    button: {
        margin: 'auto',
        width: '80%',
    },
    circularProgress: {
        margin: theme.spacing.unit,
    },
    deliveryPeriod: {
        width: '100%',
    },
    deliveryPeriodSymbol: {
        margin: 'auto',
    },
    searchResultHeader: {
        marginTop: theme.spacing.unit * 10,
    },
    searchError: {
        padding: theme.spacing.unit,
    },
    errorMessage: {
        color: 'red'
    },
    menu: {
        backgroundColor: indigo[50],
    },
});

const SELECT_PROGRESS_STATUSES = [
    {
        value: -2,
        name: "未指定"
    },
    Utility.CANCEL_REQUESTED,
    Utility.CANCEL_APPROVED,
];

export class CancelRequestList extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            dispatches: [],
            progressStatus: SELECT_PROGRESS_STATUSES[0].value,
            businessPartnerName: "",
            dispatchDestination: "",
            deliveryPeriodSince: "",
            deliveryPeriodUntil: "",
            error: [],
            isSearchRequestDispatchWait: true,
        };

        this.onChangeProgressStatus = this.onChangeProgressStatus.bind(this);
        this.onChangeBusinessPartnerName = this.onChangeBusinessPartnerName.bind(this);
        this.onChangeDispatchDestination = this.onChangeDispatchDestination.bind(this);
        this.onChangeDeliveryPeriodSince = this.onChangeDeliveryPeriodSince.bind(this);
        this.onChangeDeliveryPeriodUntil = this.onChangeDeliveryPeriodUntil.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.sellerAccount = "";
        this.buyerAccount = "";
        if(Utility.isBusinessPartnerRole(this.props.cookies.get('role'))){
            this.sellerAccount = this.props.cookies.get('id');
        }
        else{
            this.buyerAccount = this.props.cookies.get('id');
        }

        if(this.props.onScreen !== undefined){
            this.props.onScreen('キャンセル要求一覧画面');
        }
    }

    componentDidMount(){
        this.search();
    }

    handleResponse(responseJson){
        this.setState({isSearchRequestDispatchWait: false});
        if(responseJson.message === null || responseJson.message === ""){
            this.setState({dispatches: responseJson.result.TransactionInfo});
        }
        else{
            this.setState({error: responseJson.message});
        }
    }

    onChangeProgressStatus(event){
        this.setState({progressStatus: event.target.value});
    }

    onChangeBusinessPartnerName(event){
        this.setState({businessPartnerName: event.target.value});
    }

    onChangeDispatchDestination(event){
        this.setState({dispatchDestination: event.target.value});
    }

    onChangeDeliveryPeriodSince(event){
        this.setState({deliveryPeriodSince: event.target.value});
    }

    onChangeDeliveryPeriodUntil(event){
        this.setState({deliveryPeriodUntil: event.target.value});
    }

    isDisabledSearchButton(){
        if(Utility.isDateOrBlank(this.state.deliveryPeriodSince) && Utility.isDateOrBlank(this.state.deliveryPeriodUntil)){
            return false;
        }
        return true;
    }

    search(){
        this.setState({isSearchRequestDispatchWait: true}, () => {
            ApiFetcher.searchRequestDispatch(
                this.props.cookies.get('token'),
                this.sellerAccount,
                this.buyerAccount,
                this.state.progressStatus,
                this.state.businessPartnerName,
                this.state.dispatchDestination,
                this.state.deliveryPeriodSince,
                this.state.deliveryPeriodUntil,
                null,
                null,
                this.handleResponse
            )
        });
    }

    handleSubmit(){
        this.setState({
            error: [],
            dispatches: []
        }, this.search);
    }

    showResult(){
        if(this.state.isSearchRequestDispatchWait){
            return (<CircularProgress className={this.props.classes.circularProgress}/>);
        }
        else if(this.state.error.length !== 0){
            return (
                <div className={this.props.classes.searchError}>
                    {this.state.error.map((row, i) =>{
                        return (
                            <div key={i} className={this.props.classes.errorMessage}>
                                {CancelRequestList.convertErrorMessagePropertyName(row.propertyName)}{row.errorMessage}
                            </div>
                        )
                    })}
                </div>
            );
        }
        else{
            return (<RequestListTable className={this.props.classes.table} list={this.state.dispatches} detailPath={this.props.detailPath}/>);
        }
    }

    static convertErrorMessagePropertyName(propertyName){
        if(propertyName === 'sellerAccountId'){
            return '協力会社ID:';
        }
        else if(propertyName === 'buyerAccountId'){
            return 'KECID:';
        }
        else if(propertyName !== null && propertyName.match(/progressStatuses\[\d]\.progressStatus/)){
            return 'ステータス[' + propertyName.match(/\d/) + ']:';
        }
        else if(propertyName === 'progressStatuses'){
            return 'ステータス(配列):';
        }
        else if(propertyName === 'businessPartnerName'){
            return '協力会社名:';
        }
        else if(propertyName === 'dispatchDestination'){
            return '配車先:';
        }
        else if(propertyName === 'deliveryPeriodSince'){
            return '配車期間(以降を検索):';
        }
        else if(propertyName === 'deliveryPeriodUntil'){
            return '配車期間(以前を検索):';
        }
        // else if(propertyName === 'limit'){
        //     return '最大取得件数:';
        // }
        // else if(propertyName === 'offset'){
        //     return 'オフセット:';
        // }
        // else if(propertyName === 'orderby'){
        //     return 'ソート順:';
        // }
        else{
            return '';
        }
    }

    render(){
        return (
            <div className={this.props.classes.root}>
                <div>
                    <h3 className={this.props.classes.menu}>検索条件</h3>
                </div>
                <div className={this.props.classes.form}>
                    <div>
                        <TextField
                            select
                            label="ステータス"
                            selected={this.state.progressStatus}
                            onChange={this.onChangeProgressStatus}
                            SelectProps={{
                                native: true,
                            }}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                        >
                            {SELECT_PROGRESS_STATUSES.map((option, i) => (
                                <option key={i} value={option.value}>{option.name}</option>
                            ))}
                        </TextField>
                    </div>
                    {
                        Utility.isKecRole(this.props.cookies.get('role')) &&
                        <div>
                            <TextField
                                label="協力会社名"
                                type="text"
                                margin="normal"
                                variant="outlined"
                                value={this.state.businessPartnerName}
                                onChange={this.onChangeBusinessPartnerName}
                                fullWidth
                            />
                        </div>
                    }
                    <div>
                        <TextField
                            label="配車先"
                            type="text"
                            margin="normal"
                            variant="outlined"
                            value={this.state.dispatchDestination}
                            onChange={this.onChangeDispatchDestination}
                            fullWidth
                        />
                    </div>
                    <div>
                        <Grid container>
                            <Grid item xs={5}>
                                <TextField
                                    label="配車期間(以降を検索)(yyyy-MM-dd)"
                                    type="date"
                                    margin="normal"
                                    variant="outlined"
                                    defaultValue={this.state.deliveryPeriodSince}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.onChangeDeliveryPeriodSince}
                                    className={this.props.classes.deliveryPeriod}
                                />
                            </Grid>
                            <Grid item xs={2} className={this.props.classes.deliveryPeriodSymbol}>
                                <span>～</span>
                            </Grid>
                            <Grid item xs={5}>
                                <TextField
                                    label="配車期間(以前を検索)(yyyy-MM-dd)"
                                    type="date"
                                    margin="normal"
                                    variant="outlined"
                                    defaultValue={this.state.deliveryPeriodUntil}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.onChangeDeliveryPeriodUntil}
                                    className={this.props.classes.deliveryPeriod}
                                />
                            </Grid>
                        </Grid>
                    </div>
                    <div>
                        <Button disabled={this.isDisabledSearchButton()} variant="contained" color="primary" onClick={this.handleSubmit} fullWidth>検索</Button>
                    </div>
                </div>
                <div className={this.props.classes.searchResultHeader}>
                    <h3 className={this.props.classes.menu}>検索結果</h3>
                </div>
                <Paper className={this.props.classes.paper}>
                    {this.showResult()}
                </Paper>
                <div className={this.props.classes.button}>
                    <Button component={(props) => <Link to={this.props.backPath} {...props}/>} variant="contained" color="primary" fullWidth>トップ画面へ戻る</Button>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(CancelRequestList);